<template>
  <div>
    <h5 class="text-grey-6 uppercase no-margin q-headline q-pb-sm">Persons Connected to this Company</h5>
    <div class="mdi-card full-width q-pa-md">
      <div class="row" v-if="companyId">
        <div class="col-12">
          <q-table
            ref="table"
            :data="persons"
            :columns="columns"
            :filter="terms"
            :filter-method="myFilter"
            row-key="id"
            :pagination.sync="pagination"
            :rows-per-page-options="[0, 25, 50, 100, 250]"
            :loading="loading"
            class="q-pa-md no-shadow"
          >
            <template slot="top-left" slot-scope="props">
              <q-search hide-underline v-model="terms"/>
            </template>
            <q-tr slot="body" slot-scope="props" :props="props">
              <!-- <q-td key="id" :props="props">{{ props.row.id }}</q-td> -->
              <q-td key="id" :props="props">
                <q-btn icon="edit" size="sm" flat color="primary" @click="openModal(props.row.id)"/>
              </q-td>
              <q-td key="firstName" :props="props">
                <router-link :to="`/person/edit/${props.row.id}`">{{ props.row.firstName }}</router-link>
              </q-td>
              <q-td key="lastName" :props="props">
                <router-link :to="`/person/edit/${props.row.id}`">{{ props.row.lastName }}</router-link>
              </q-td>
              <q-td key="profession" :props="props">{{ props.row.profession }}</q-td>
              <q-td key="emailAddress" :props="props">
                <a :href="`mailto:${props.row.emailAddress}`">{{ props.row.emailAddress }}</a>
              </q-td>
              <q-td key="homeNumber" :props="props">
                <a :href="`tel:${props.row.homeNumber}`">{{ props.row.homeNumber }}</a>
              </q-td>
              <q-td key="workNumber" :props="props">
                <a :href="`tel:${props.row.workNumber}`">{{ props.row.workNumber }}</a>
              </q-td>
              <q-td key="cellNumber" :props="props">
                <a :href="`tel:${props.row.cellNumber}`">{{ props.row.cellNumber }}</a>
              </q-td>
              <!--<q-td key="removalDate" :props="props">
                <template v-if="props.row.removalDate">
                  Yes <q-icon name="delete" color="negative" />
                </template>
                <template v-else>
                  No <q-icon name="done" color="positive" />
                </template>
              </q-td>-->
            </q-tr>
          </q-table>
        </div>
      </div>
    </div>
    <!-- EDIT FORM -->
    <div v-if="editFormModalOpen">
      <q-modal
        v-model="editFormModalOpen"
        content-classes="q-pa-lg"
        content-css="min-width: 70vw; max-width: 95vw"
        no-backdrop-dismiss
        no-esc-dismiss
      >
        <div class="fit">
          <q-btn
            flat
            icon="close"
            class
            style="top: 0; right: 0; position: relative; float: right"
            @click="editFormModalOpen=false"
          ></q-btn>
          <div v-if="editFormModelId">
            <base-form
              v-if="relationResource"
              :resource="relationResource"
              :callback="handleEdit"
              :is-modal="true"
              :id="editFormModelId"
            >
              <div slot="goback" class="full-width q-mt-md q-pb-lg">
                <q-btn
                  icon="close"
                  label="Cancel / Close"
                  color="grey-6"
                  @click="editFormModalOpen=false"
                  flat
                />
              </div>
            </base-form>
          </div>
        </div>
      </q-modal>
    </div>
  </div>
</template>
<script>
import colorsMixin from '../../mixins/colors'

export default {
  name: 'CompanyPersons',
  mixins: [colorsMixin],
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      persons: [],
      filter: '',
      terms: '',
      loading: false,
      editFormModalOpen: false,
      relationResource: 'person',
      editFormModelId: false,
      pagination: {
        sortBy: 'firstName', // String, column "name" property value
        descending: false,
        page: 1,
        rowsPerPage: 100 // current rows per page being displayed
      },
      columns: [
        {
          name: 'id',
          required: true,
          label: 'Edit/View',
          align: 'left',
          field: 'id',
          sortable: true
          // classes: 'my-class',
          // style: 'width: 500px'
        },
        {
          name: 'firstName',
          required: false,
          label: 'First Name',
          align: 'left',
          field: 'firstName',
          sortable: true
          // classes: 'my-class',
          // style: 'width: 500px'
        },
        {
          name: 'lastName',
          required: false,
          label: 'Last Name',
          align: 'left',
          field: 'lastName',
          sortable: true
          // classes: 'my-class',
          // style: 'width: 500px'
        },
        {
          name: 'profession',
          required: false,
          label: 'Title',
          align: 'left',
          field: 'profession',
          sortable: true
          // classes: 'my-class',
          // style: 'width: 500px'
        },
        {
          name: 'emailAddress',
          required: false,
          label: 'Email',
          align: 'left',
          field: 'emailAddress',
          sortable: true
          // classes: 'my-class',
          // style: 'width: 500px'
        },
        {
          name: 'homeNumber',
          required: false,
          label: 'Phone Number',
          align: 'left',
          field: 'homeNumber',
          sortable: true
          // classes: 'my-class',
          // style: 'width: 500px'
        },
        {
          name: 'workNumber',
          required: false,
          label: 'Work Number',
          align: 'left',
          field: 'workNumber',
          sortable: true
          // classes: 'my-class',
          // style: 'width: 500px'
        },
        {
          name: 'cellNumber',
          required: false,
          label: 'Cell Number',
          align: 'left',
          field: 'cellNumber',
          sortable: true
          // classes: 'my-class',
          // style: 'width: 500px'
        }
        // {
        //   name: 'removalDate',
        //   required: false,
        //   label: 'Deleted',
        //   align: 'left',
        //   field: 'removalDate',
        //   sortable: true
        //   // classes: 'my-class',
        //   // style: 'width: 500px'
        // }
      ]
    }
  },
  computed: {
    companyId () {
      if (this.$route && this.$route.params && this.$route.params.id) {
        return parseInt(this.$route.params.id)
      }
      return false
    }
  },
  methods: {
    async request () {
      if (this.companyId) {
        this.loading = true
        const config = {
          params: {
            $filter: `companyId eq ${this.companyId} and removalDate eq null and approved eq true`,
            // $filter: `companyId eq ${this.companyId} `,
            limit: 100
          }
        }
        try {
          const { data } = await this.$axios.get('/api/odata/person/paginate', config)
          if (data) {
            this.persons = data.data
            this.loading = false
          } else {
            this.$q.notify({
              message: 'Error fetching Person Records 1'
            })
            this.ready = true
            this.loading = false
          }
        } catch (e) {
          this.$q.notify({
            message: 'Error fetching Person Records 2'
          })
          this.loading = false
        }
      }
    },
    myFilter (rows, terms, cols, cellValue) {
      const lowerTerms = terms ? terms.toLowerCase() : ''
      return rows.filter(row => cols.some(col => (cellValue(col, row) + '').toLowerCase().indexOf(lowerTerms) !== -1))
    },
    openModal (id) {
      this.editFormModalOpen = true
      this.editFormModelId = id
    },
    handleEdit (model) {
      // console.log('relationFields handleEdit', model)
      this.$q.notify({
        message: `Person Updated`,
        type: 'positive'
      })
      this.editFormModalOpen = false
      this.editFormModelId = false
      this.request()
      // this.selected(model)
      // this.$set(this, 'editFormModalOpen', false)
    }
  },
  async mounted () {
    this.request()
  }
}
</script>
